import React, { useState, useEffect } from "react";

import { useParams } from "react-router-dom";

import { Formik, Field } from "formik";
import { ToastContainer } from "react-toastify";
import { message, Pagination, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import Loadar from "../../common/loader/Loader";
import CustomInputField from "../../common/CustomInputField";
import Breadcrumbs from "../../common/breadcrumb/Breadcrumbs";
import {
  getPayinPayoutRequestView,
  usersListForResellerPartnerApiUser,
  payinPayoutRequestApprove,
  getPayinPayoutRequestExcelView,
} from "../../api/login/Login";
import Select from "react-select";
import { Form, Modal } from "react-bootstrap";
import * as Yup from "yup";
import CustomTextArea from "../../common/CustomTextArea";
import InputGroup from 'react-bootstrap/InputGroup';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
const status = {
  Pending: "Pending",
  Approved: "Approved",
  Rejected: "Rejected",
};

const breadCrumbsTitle = {
  id: "1",
  title_1: "Payments",
  path_1: "/admin/pay-in-to-pay-out-request",
  title_2: "PayIn to Main Wallet Request View ",
};

const PayInPayoutRequest = () => {
  const param = useParams();
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [steps, setSteps] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [userList, setUserList] = useState([]);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const [resetKey, setResetKey] = useState(false);
  const defaultInitialValues = {
    start_date: "",
    user: "",
    max_amt: "",
    min_amt: "",
    end_date: "",
    status: "",
  };
  const resetValues = {
    start_date: "",
    end_date: "",

    status: "",
    user: "",
    max_amt: "",
    min_amt: "",
  };
  const [initialValues, setInitialValues] = useState(defaultInitialValues);
  const handleReset = (resetForm) => {
    resetForm();
    setInitialValues(resetValues);
    setFormKey((prev) => prev + 1);
    setCurrentPage(1);
    setResetKey((pre) => !pre);
    // getDmtTxnData(0);
  };

  const handleSubmitFilter = (values) => {
    console.log("fire");
    setCurrentPage(1);
    setInitialValues(values);
    setResetKey((pre) => !pre);
    // Add your API call here
  };

  const onChangeVal = (page) => {
    setResetKey((pre) => !pre);
    setCurrentPage(page);
  };

  const getData = async () => {
    let body = {
      ...initialValues,
      page: currentPage,
      count: 10,
    };
    let res = await getPayinPayoutRequestView(body);
    setData(res?.data);
  };


  const downloadExcel = async () => {
    try {
      setLoading(true);
     
  
      const res = await getPayinPayoutRequestExcelView(initialValues);
     
      if (res?.data?.requestList?.length > 0) {
      
        const ws = XLSX.utils.json_to_sheet(res?.data?.requestList);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Transfer_Pay_In_Approval_Report");
        XLSX.writeFile(wb, `Transfer_Pay_In_Approval_Report_${new Date().toLocaleDateString()}.xlsx`);
      } else {
        message.error('No data available to export!');
      }
    } catch (error) {
      message.error('Failed to download Excel. Please try again.');
    } finally {
      setLoading(false);
    }
  };   



  useEffect(() => {
    getData();
  }, [resetKey, currentPage]);

  // filter data //

  useEffect(() => {
    fetchUserType();
  }, []);

  const fetchUserType = async () => {
    try {
      const response = await usersListForResellerPartnerApiUser();
      let user =
        response?.data?.map((user) => ({
          value: user._id,
          label: user.name,
        })) || [];
      setUserList(user);
    } catch (error) {}
  };

  const handleClose = () => {
    setOpenPopup(false);
  };

  const handleOpenPopup = (value) => {
  
    setSelectedUser(value);
    setStatusUpdate({
      amount: value?.amount,
      status: value?.status || "",
      authority_remark: value?.authority_remark || "",
      email: "",
      password: "",
      pin: "",
    });
    setSteps(1);
    setOpenPopup(true);
  };
  

  const stepOneValidationSchema = Yup.object().shape({
    status: Yup.string().required("Status is required"),
    authority_remark: Yup.string().required("Authority remark is required"),
  });
  


  const stepTwoValidationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string().required("Password is required"),
    pin: Yup.string()
      .required("TPIN is required")
      .matches(/^\d{4}$/, "TPIN must be exactly 4 digits"),
  });

  const [statusUpdate, setStatusUpdate] = useState({
    amount: "",
    status: "",
    authority_remark: "",
    email: "",
    password: "",
    pin: "",
  });


  console.log(statusUpdate , "sstatusupdate")
  

    const [showPassword, setShowPassword] = useState(false);
  return (
    <>
      {loading && <Loadar />}
      <ToastContainer />

      <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />

      {/* // Filter Option // */}
      <div className="row m-4">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <div className="table-responsive active-projects style-1">
                <div className="tbl-caption tbl-caption-2">
                  <h4 className="heading mb-0">
                    <b>{breadCrumbsTitle.title_2} Search</b>
                  </h4>
                </div>
                <Formik
                  key={formKey}
                  initialValues={initialValues}
                  onSubmit={handleSubmitFilter}
                  enableReinitialize
                >
                  {({
                    values,
                    errors,
                    touched,
                    resetForm,
                    handleChange,
                    setFieldValue,
                    handleBlur,
                    handleSubmit
                  }) => (
                    <Form onSubmit={handleSubmit} className="tbl-captionn">
                      <div className="row">
                        <div className="col-xl-4 mb-3">
                          <Field
                            as={CustomInputField}
                            type="date"
                            name="start_date"
                            placeholder="Start Date"
                            hasError={touched.start_date && errors.start_date}
                            errorMsg={errors.start_date}
                          />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Field
                            as={CustomInputField}
                            type="date"
                            name="end_date"
                            placeholder="End Date"
                            hasError={touched.end_date && errors.end_date}
                            errorMsg={errors.end_date}
                          />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Field
                            as={CustomInputField}
                            type="number"
                            name="min_amt"
                            placeholder="Min Amount"
                            hasError={touched.min_amt && errors.min_amt}
                            errorMsg={errors.min_amt}
                          />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Field
                            as={CustomInputField}
                            type="number"
                            name="max_amt"
                            placeholder="Max Amount"
                            hasError={touched.max_amt && errors.max_amt}
                            errorMsg={errors.max_amt}
                          />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Select
                            id="user"
                            name="user"
                            options={userList}
                            value={
                              userList.find(
                                (option) => option.value === values.user
                              ) || null
                            }
                            onChange={(option) =>
                              setFieldValue("user", option?.value || "")
                            }
                            onBlur={handleBlur}
                            placeholder="Select User"
                            isClearable
                          />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Field
                            as="select"
                            className="form-select"
                            name="status"
                          >
                            <option value="">Select Status</option>
                            {Object?.entries(status)?.map(([key, value]) => (
                              <option value={key}>{value}</option>
                            ))}
                          </Field>
                        </div>

                        <div className="d-flex justify-content-start">
  <button
    className="btn btn-primary me-2"
    type="submit"
  >
    <i className="fas fa-search"></i> Search
  </button>
  <button
    className="btn btn-secondary"
    type="button"
    onClick={() => handleReset(resetForm)}
  >
    <i className="fas fa-refresh"></i> Reset
  </button>
</div>

                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* // filter option end here  */}

      {/* // table section  */}
      {data?.requestList?.length > 0 ? (
        <>
          <section className="ListDistributer exppdf">
            <div className="row m-4">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body p-0">
                    <div className="table-responsive active-projects style-1">
                      <div className="tbl-caption">
                        <h4 className="heading mb-0">
                          <b>{breadCrumbsTitle.title_2} List</b>
                        </h4>
                        <div className="d-flex">
                          <button
                            onClick={downloadExcel}
                            className="btn btn-primary border border-white"
                          >
                            {" "}
                            <DownloadOutlined /> Download Excel
                          </button>
                        </div>
                      </div>
                         <div className="p-3">
                                    <h3 className="totalAmountstyle">Total Amount: <b>{data?.totalAmount || 0}</b></h3>
                                </div>
                      <div
                        id="empoloyees-tblwrapper_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="table-to-xls"
                          className="table dataTable no-footer"
                          role="grid"
                          aria-describedby="empoloyees-tblwrapper_info"
                        >
                          <thead>
                            <tr role="row">
                              <th>Sr. No</th>
                              <th>Date / Time</th>
                              <th>Name</th>
                              <th>Amount</th>
                              <th>Member Code</th>
                              <th>User Type</th>
                              <th>Remarks</th>
                              <th>Authority Remarks</th>
                              <th>Approved By</th>
                              <th>Payment Updated Date</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.requestList?.map((item, i) => (
                              <tr key={i} role="row" className="odd">
                                <td>{i + 1}</td>
                                <td>{item?.paymentReqDate}</td>
                                <td>{item?.username}</td>
                                <td>{item?.amount}</td>
                                <td>{item?.member_code}</td>
                                <td>{item?.user_type}</td>
                                <td>{item?.remark}</td>
                                <td>{item?.authority_remark}</td>
                                <td>{item?.approvedBy}</td>
                                <td>{item?.paymentAproveRejectDate}</td>

                                <td>
                                  {item?.status === "Pending" && (
                                    <button
                                      className="btn btn-warning"
                                      onClick={()=>handleOpenPopup(item)}
                                    >
                                      Pending
                                    </button>
                                  )}
                                  {item?.status === "Approved" && (
                                    <button className="btn btn-success">
                                      Approved
                                    </button>
                                  )}
                                  {item?.status === "Rejected" && (
                                    <button className="btn btn-danger">
                                      Rejected
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        className="dataTables_info"
                        id="empoloyees-tblwrapper_info"
                        role="status"
                        aria-live="polite"
                      >
                        Total {data?.totalCount} entries
                      </div>
                      <div
                        className="dataTables_paginate paging_simple_numbers"
                        id="empoloyees-tblwrapper_paginate"
                      >
                        <Pagination
                          /* showSizeChanger
                                            onShowSizeChange={''} */

                          // defaultCurrent={1}
                          // onChange={onChangeVal}
                          total={data?.totalCount}
                          //   pageSize={10}
                          current={currentPage}
                          onChange={onChangeVal}
                        />
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </section>
        </>
      ) : (
        <div className="text-center mt-4">
          <h3>No data available</h3>
        </div>
      )}
      {/* // table section  */}

      <Modal
        show={openPopup}
        onHide={handleClose}
        className="dilog-box newcuss"
        id="dilog-box"
      >
        <Modal.Header closeButton>
          <span style={{ fontSize: "20px", color: "var(--nav)" }}>
            <b>Update Payment Status</b>
          </span>
        </Modal.Header>

        <Modal.Body style={{ paddingTop: "0px" }}>
        <h4 className='py-2 px-2 text-primary'>User Wallet Balance : <span>
                    {selectedUser?.payin_wallet || 0}
                    </span> </h4> 
  <Formik
    initialValues={statusUpdate}
    enableReinitialize
    validationSchema={steps === 1 ? stepOneValidationSchema : stepTwoValidationSchema}
    onSubmit={async(values) => {
      if (steps === 1) {
        setStatusUpdate(values);
        setSteps(2);
      } else {
        // Final submit logic here
        console.log("Final Submit:", values);
            let body = {
                ...values,
                paymentReqId : selectedUser?._id
            }
          try {
            let res  = await payinPayoutRequestApprove(body)
             
              if(res?.error === false)
              {
                message.success(res?.message);
                setOpenPopup(false);
              }
              else{
                message.error(res?.message)
              }
              setResetKey((pre) => !pre);
          } catch (error) {
            
          } finally {
            
          }
      
        
      }
    }}
  >
    {({ values, handleChange, handleSubmit, errors, touched }) => (
      <Form onSubmit={handleSubmit} className="cusformsnew">
        {steps === 1 ? (
          <>
            <div className="row mt-4">
              <div className="col-xl-6 mb-3">
                <Field
                  as={CustomInputField}
                  type="number"
                  name="amount"
                  placeholder="Amount"
                  readOnly
                  
                />
              </div>

              <div className="col-xl-6 mb-3">
                <select
                  className={`form-select ${touched.status && errors.status ? "is-invalid" : ""}`}
                  name="status"
                  value={values.status}
                  onChange={handleChange}
                >
                  <option value="">Select Status</option>
                  {Object?.entries(status)?.map(([key, value]) => (
                    <option key={key} value={key}>{value}</option>
                  ))}
                </select>
                {touched.status && errors.status && (
                  <div className="invalid-feedback">{errors.status}</div>
                )}
              </div>

              <div className="col-xl-12 mb-3">
              <CustomTextArea
                                                    type="text"
                                                    value={values.authority_remark}
                                                    hasError={errors.authority_remark && touched.authority_remark}
                                                    onChange={handleChange}
                                                  
                                                    errorMsg={errors.authority_remark}
                                                    
                                                    id="authority_remark"
                                                    name="authority_remark"
                                                    placeholder="Authority Remark"
                                                />
 
</div>

            </div>

            <div className="text-end">
              <Button type="primary" htmlType="submit">
                Continue
              </Button>
            </div>
          </>
        ) : (
          <>
            <Form.Group controlId="formEmail" className="mb-3 mt-4">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={values.email}
                autoComplete='new-email'
                onChange={handleChange}
                isInvalid={touched.email && !!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formPassword" className="mb-3">
              <Form.Label>Password</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  name="password"
                   autoComplete='new-password'
                  value={values.password}
                  onChange={handleChange}
                  isInvalid={touched.password && !!errors.password}
                />
                <span
                  style={{
                    width: "50px",
                    height: "42px",
                    marginTop:'4px',
                    cursor: "pointer",
                    border: "1px solid #CCCCCC",
                  }}
                  onClick={() => setShowPassword(!showPassword)}
                  className="d-flex justify-content-center align-items-center"
                >
                  {showPassword ? <AiFillEyeInvisible size={16} /> : <AiFillEye size={16} />}
                </span>
                <Form.Control.Feedback type="invalid">
                  {errors.password}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>

            <Form.Group controlId="formTPIN" className="mb-3">
              <Form.Label>TPIN</Form.Label>
              <Form.Control
                 type="password"
                 name="pin"
                 value={values.pin}
                 onChange={(e) => {
                   const val = e.target.value;
                   if (/^\d{0,4}$/.test(val)) {
                     handleChange(e); // update formik value
                   }
                 }}
                 isInvalid={touched.pin && !!errors.pin}
                 maxLength={4} // hard limit to 4 characters
                 inputMode="numeric" // for mobile number keypad
              />
              <Form.Control.Feedback type="invalid">
                {errors.pin}
              </Form.Control.Feedback>
            </Form.Group>

            <div className="d-flex justify-content-between">
              <Button variant="secondary" onClick={() => setSteps(1)}>
                Back
              </Button>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </div>
          </>
        )}
      </Form>
    )}
  </Formik>
</Modal.Body>

      </Modal>
    </>
  );
};

export default PayInPayoutRequest;
